import { render, staticRenderFns } from "./CmsImportParts.vue?vue&type=template&id=5d2d4ffd&"
import script from "./CmsImportParts.vue?vue&type=script&lang=ts&"
export * from "./CmsImportParts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports